import { useQuery } from "@tanstack/react-query";
import { fetchData } from "../../services/api";
import { parkingQueryKeys } from "../../constants";
import { minutes } from "utils/time";
import { ISection } from "types/parkingSection.type";

interface IUseGetParkingZoneParams {
    sectionCode: string;
}

export const useGetParkingZone = (params: IUseGetParkingZoneParams) => {
    const { sectionCode } = params;

    return useQuery({
        queryKey: parkingQueryKeys.section.get(sectionCode),
        staleTime: minutes(5),
        gcTime: minutes(30),
        enabled: !!sectionCode,
        queryFn: async (): Promise<ISection[]> => {
            const response = await fetchData<ISection[]>("StreetParking/sections/1", "GET", "url", {
                sectionCode,
            });

            return response;
        },
    });
};
